import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing }
		],
    isLoading: _ctx.isLoading,
    loadingType: _ctx.loadingType
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel CampaignSettingsInputRequired" }, " Client Services ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MultiSelect, {
          ref: "clientServicesPersonDropdown",
          label: "Client Services",
          placeholder: " ",
          class: "CampaignEditorDropdown",
          searchable: true,
          options: _ctx.options,
          onUpdated: _ctx.setClientServicesPerson
        }, null, 8 /* PROPS */, ["options", "onUpdated"]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ValidationMessage" }, " This field must be completed before proceeding ", -1 /* CACHED */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading", "loadingType"]))
}